const AppInput = ({
    label,
    type = "text",
    placeholder,
    value,
    onChange,
    className = "htLabel",
    register,
    readonlyInput = false,
    error = false,
    classDiv = "",
    onClick,
    iconInput = "",
    maxLength
}) => {

    return (
        <div className={`htInputField ${classDiv}`}>
            <label className={className}>{label}</label>
            <input
                type={type}
                value={value}
                onChange={onChange}
                className="htInput mt-7 mn-input"
                placeholder={placeholder}
                readOnly={readonlyInput}
                {...register}
                onClick={onClick}
                maxLength={maxLength}
            />
            {error && <span className="htError">{error?.message}</span>}
            {iconInput && (
                <div className="nh-icon-input">
                    <img src={iconInput} />
                </div>
            )}
        </div>
    );
};

export default AppInput;
